import React from 'react';
import LineItemProductWizard from './LineItemProductWizard';

/**
 * Quote line items: delegates to {@link LineItemProductWizard}.
 * Backup of the previous standalone implementation: `QuoteProductWizard.legacy.js`.
 */
const QuoteProductWizard = props => (
  <LineItemProductWizard
    lineItemContext="quote"
    parentId={props.quoteId}
    parentCurrency={props.quoteCurrency}
    show={props.show}
    onHide={props.onHide}
    onSaveSuccess={props.onSaveSuccess}
    lineItemWizardConfig={props.lineItemWizardConfig}
  />
);

export default QuoteProductWizard;
